import { CodeCheckBoxListComponent } from './code-check-box-list.component';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * コードチェックボックスモデルクラス
 *
 * @export CodeCheckBoxListModel
 * @class CodeCheckBoxListModel
 */
export class CodeCheckBoxListModel {

  /** コードリスト 表示内容および選択値を持つ */
  public codeList: any[] = [];
  /* リストインスタンス(コンポーネント) */
  public codeListUI: CodeCheckBoxListComponent;
  /* コードリスト取得完了 */
  public completeUpdateCodeList: boolean = <boolean>false;
  /* 初期設定コード値 */
  public setCodeValue: string = <string>'';
  /* 表示させないコード */
  public invalidCode: string = <string>'';

  /**
   * コンストラクタ。初期値の設定を行う
   */
  public CodeCheckBoxListManage() {
  }


  /**
   * コードリストを更新する
   *
   * @param serverData コードリストのサーバ取得データ
   */
  public updateCodeList(serverData: any[]): void {
    // NULLチェック追加
    if (serverData == null) {
      this.codeList = [];
      this.codeList.push(this.getBlankObject('', ''));

      return;
    }

    // コード一覧を作成
    // 表示させないコード値をリストから削除する
    const tmpList = serverData;

    // 表示するリスト
    const tempCodeList: any[] = [];

    // 表示させないコードを取得
    const invalidCodeList = this.invalidCode.split(',');

    for (let i: any = 0; i < tmpList.length; i++) {
      const tempCodeListIdx: any = invalidCodeList.lastIndexOf(tmpList[i].CodeValue);
      if (tempCodeListIdx === -1) {
        // 非表示の文字列がなかった場合
        // チェックボックスのON/OFF保存変数を追加
        tmpList[i].selectedValue = false;

        // 表示リストに追加
        tempCodeList.push(tmpList[i]);
      }
    }

    let index: number = <number>0;

    // コード+：+名称追加
    for (; index < tempCodeList.length; index++) {
        tempCodeList[index].codeValueName = tempCodeList[index].CodeValue + ':' + tempCodeList[index].CodeName;
    }

    this.codeList = tempCodeList;

    this.completeUpdateCodeList = true;

    this.codeListUI.updateSelectedCodeValue();
  }

  /**
   * 空白のオブジェクトを取得する
   * @return Object:オブジェクト
   */
  private getBlankObject(codeValue: string, codeName: string): any {
    return {
      CodeDiv: '',
      CodeValue: codeValue,
      CodeName: codeName,
      CodeDivName: '',
      codeValueName: !PlessViewUtilsSub.isEmpty(codeValue) && !PlessViewUtilsSub.isEmpty(codeName) ?
      codeValue + ':' + codeName : codeValue + codeName,
      Reserve1: '',
      Reserve2: '',
      ReserveNum1: '',
      ReserveNum2: '',
      SortNum: '',
      StartOrderCode: '',
      EndOrderCode: ''
    };
  }

}
